export default "__VITE_ASSET__CA8dVz25__"